import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import * as fromGraphql from "./citizens-services-category.graphql";
import * as fromActions from "./citizens-services-category.actions";
import {map, switchMap} from 'rxjs';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';


@Injectable()
export class CitizensServicesCategoryEffects {


  citizenGetCategories$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.citizenGetCategories),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_CITIZEN_SERVICES_CATEGORY,
        fetchPolicy: 'network-only',
        variables:{}
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching service'),
        map(({ data }: any ) => {
          if (data) {
            const result: any =  data?.citizenGetCategories
            result?.response?.status ? this.store.dispatch(fromActions.loadCitizensServicesCategorys({ citizensServicesCategorys: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService
  ) {}
}
